import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { SportIntervalCounts } from '@frontend/sports/calendar/data-access';
import { CalendarService } from '@frontend/sports/calendar/feature';
import { Observable, firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CalendarResolver {
    private service = inject(CalendarService);

    resolve(route: ActivatedRouteSnapshot): Observable<SportIntervalCounts> {
        return this.service.getCalendarCounts(route.params.sport);
    }

    preResolve(route: ActivatedRouteSnapshot) {
        firstValueFrom(this.service.getCalendarCounts(route.params.sport));
    }
}
